import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44965fb3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-container" }
const _hoisted_2 = { class: "card-container__logo" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "card-container__description" }
const _hoisted_5 = { class: "card-container__description__name" }
const _hoisted_6 = {
  class: "card-container__description__company",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "card-container__description__published" }
const _hoisted_9 = { class: "card-container__button" }
const _hoisted_10 = {
  key: 0,
  class: "card-container--info"
}
const _hoisted_11 = { class: "card-container--info__company" }
const _hoisted_12 = { class: "card-container--info__name" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "card-container--info__button" }
const _hoisted_15 = ["href"]
const _hoisted_16 = {
  class: "p-d-flex",
  style: {"flex":"1","justify-content":"end"}
}
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "modal--container" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "modal--title" }, [
  /*#__PURE__*/_createTextVNode("Antes de aplicar, necesitas completar los siguientes "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("datos en tu "),
  /*#__PURE__*/_createElementVNode("span", null, "perfil de Coderhouse:")
], -1))
const _hoisted_20 = { class: "modal--form" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = {
  key: 0,
  class: "modal--form-field--input"
}
const _hoisted_23 = ["onUpdate:modelValue"]
const _hoisted_24 = {
  key: 1,
  class: "modal--form-field--input"
}
const _hoisted_25 = {
  key: 2,
  class: "modal--form-field--input",
  style: {"margin-top":"12px"}
}
const _hoisted_26 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_chevron_up = _resolveComponent("chevron-up")!
  const _component_icon = _resolveComponent("icon")!
  const _component_Button = _resolveComponent("Button")!
  const _component_SelectInput = _resolveComponent("SelectInput")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: _ctx.jobOffer.companyLogo || require('@/assets/job-market-logo.jpg'),
          alt: _ctx.jobOffer.companyName || 'Logo'
        }, null, 8, _hoisted_3)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.jobOffer.title), 1),
        _createElementVNode("p", _hoisted_6, [
          _createTextVNode(_toDisplayString(_ctx.jobOffer.companyName) + " ", 1),
          _createElementVNode("img", {
            src: require('@/assets/icons/location.svg'),
            alt: "location",
            style: _normalizeStyle([{"margin":"0 4px 0 0px","height":"14px"}, {'margin-left': _ctx.jobOffer.companyName ? '16px' : '0px'}])
          }, null, 12, _hoisted_7),
          _createTextVNode(" " + _toDisplayString(_ctx.jobOffer.locationRestrictions?.join(', ')), 1)
        ]),
        _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.publishedDate), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showDescription = !_ctx.showDescription)),
          class: _normalizeClass(["button", _ctx.showDescription ? 'card-container__button__chevron--up' : 'card-container__button__chevron--down'])
        }, [
          _createVNode(_component_icon, {
            size: 24,
            strokeColor: "#eaff6a"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_chevron_up)
            ]),
            _: 1
          })
        ], 2)
      ])
    ]),
    (_ctx.showDescription)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.jobOffer.companyName), 1),
          _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.jobOffer.title), 1),
          _createElementVNode("p", {
            class: "card-container--info__description",
            innerHTML: _ctx.jobDescription
          }, null, 8, _hoisted_13),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("a", {
              href: _ctx.jobOffer.applyNowLink,
              target: "_blank"
            }, [
              _createVNode(_component_Button, {
                class: "button",
                label: "Aplicar",
                onClick: _ctx.applyCTA
              }, null, 8, ["onClick"])
            ], 8, _hoisted_15)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Dialog, {
      visible: _ctx.showModal,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showModal) = $event)),
      modal: true,
      closable: false,
      draggable: false,
      class: "application--modal"
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("img", {
            class: "close-modal",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeModal())),
            src: require('@/assets/icons/Light_X.svg'),
            alt: "Close modal",
            style: {"cursor":"pointer","z-index":"999"}
          }, null, 8, _hoisted_17)
        ])
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "Aplicar",
          class: "primary",
          onClick: _ctx.apply
        }, null, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.wrangleInputs, (item, parentIndex) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "modal--form-field",
                key: parentIndex
              }, [
                _createElementVNode("label", null, [
                  _createTextVNode(_toDisplayString(item.label) + " ", 1),
                  (item.required)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_21, "(*)"))
                    : _createCommentVNode("", true)
                ]),
                (item.type === 'text' || item.type === 'file' || (item.tag === 'input' && !item.options))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": ($event: any) => ((_ctx.wrangleInputs[parentIndex].value) = $event)
                      }, null, 8, _hoisted_23), [
                        [_vModelText, _ctx.wrangleInputs[parentIndex].value]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (item.type === '' || item.tag === 'select')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createVNode(_component_SelectInput, {
                        class: "p-mt-3",
                        name: item.label,
                        options: item.options,
                        valueSuggested: item.options ? item.options[0].value : ''
                      }, null, 8, ["name", "options", "valueSuggested"])
                    ]))
                  : _createCommentVNode("", true),
                (item.type === 'checkbox')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.options, (option, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "p-field-checkbox",
                          key: index
                        }, [
                          _createVNode(_component_Checkbox, {
                            class: "ch-checkbox",
                            id: option.value,
                            name: option.label,
                            value: option.value,
                            modelValue: _ctx.wrangleInputs[parentIndex].value,
                            "onUpdate:modelValue": ($event: any) => ((_ctx.wrangleInputs[parentIndex].value) = $event)
                          }, null, 8, ["id", "name", "value", "modelValue", "onUpdate:modelValue"]),
                          _createElementVNode("label", {
                            class: "label-text",
                            for: option.value
                          }, _toDisplayString(option.label), 9, _hoisted_26)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}